var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('Modal', {
    attrs: {
      "title": $t("g7hb15", "校验MFA"),
      "close": "",
      "mask-closable": false,
      "closable": false
    },
    on: {
      "on-ok": _vm.handleSubmitAuthMFA,
      "on-cancel": _vm.handleCancelAuthMFA
    },
    model: {
      value: _vm.showAuthMFA,
      callback: function ($$v) {
        _vm.showAuthMFA = $$v;
      },
      expression: "showAuthMFA"
    }
  }, [_c('Alert', {
    scopedSlots: _vm._u([{
      key: "desc",
      fn: function () {
        var _vm$issuer;
        return [_c('div', {
          staticClass: "safe-team"
        }, [_c('div', {
          staticClass: "safe"
        }, [_c('span', [_vm._v(_vm._s(`${(_vm$issuer = _vm.issuer) === null || _vm$issuer === void 0 ? void 0 : _vm$issuer.issuer}（${_vm.unitCode}）`))])])]), _c('div', [_c('SafetyCodeInput', {
          ref: "validForm",
          on: {
            "validate": _vm.handleSubmitAuthMFA
          }
        })], 1)];
      },
      proxy: true
    }])
  }), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    on: {
      "click": _vm.handleCancelAuthMFA
    }
  }, [_vm._v($t("q2w9b66", "返回单位选择"))]), _c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleSubmitAuthMFA
    }
  }, [_vm._v($t("fuj3jx4", "立即验证"))])], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };